import App from "../vue/App.vue";
import Cookies from "js-cookie";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

// App main
const main = async() => {
  // Async load the Vue 3 APIs we need rom the Vue ESM
  const { createApp } = await import(/* webpackChunkName: "vue" */ 'vue');

  // Create our vue instance
  const app = createApp(App);

  // Mount the app
  const root = app.mount('#app');

  return root;
}

// Execute async function
main().then((root) => {
  window.onload = () => {
    setTimeout(function () {
      let app = document.getElementById('app');
      if (app) { app.style.opacity='1.0'; }

      const MODAL_KEY = '_schoolChoiceModal';
      let hasSeenSchoolModal = Cookies.get(MODAL_KEY);
      let schoolModal = document.getElementById('SchoolChoiceModal');

      if(!hasSeenSchoolModal && schoolModal) {
        setTimeout(() => {
            schoolModal.classList.add('is-visible');
            Cookies.set(MODAL_KEY, 'value', { expires: 7 });
            disableBodyScroll(schoolModal);
            let closeButtons = Array.from(schoolModal.querySelectorAll('[aria-label="Close"]'));

            closeButtons.forEach(cb => {
              cb.addEventListener('click', () => {
                schoolModal.classList.remove('is-visible');
                enableBodyScroll(schoolModal);
              });
            })
        }, 50);
      }

      let csrfInputs = Array.from(document.querySelectorAll('input[name="CRAFT_CSRF_TOKEN"]'));
      if(csrfInputs.length > 0) {
        updateForms(csrfInputs);
      }
    }, 10);


  }
});

/*
import $ from 'jquery'
$(document).ready(function () {
if (document.cookie.indexOf("FooBar=true") == -1) {
document.cookie = "FooBar=true; max-age=86400"; // 86400: seconds in a day
$('#MyModal').modal('show');
}
});
*/

const getSessionInfo = function() {
  return fetch('/actions/users/session-info', {
    headers: {
      'Accept': 'application/json',
    },
  })
  .then(response => response.json());
};

const updateForms = async (forms) => {
  const sessionInfo = await getSessionInfo();
  forms.forEach(input => {
    input.value = sessionInfo.csrfTokenValue;
  });
}